const timezoneOffsetPattern = /(?:Z|[+-]\d{2}:?\d{2})$/i;
const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
const isoDateTimeWithoutOffsetPattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,7})?)?$/;

const defaultDateTimeFormatOptions: Intl.DateTimeFormatOptions = {
    dateStyle: 'short',
    timeStyle: 'medium',
    timeZone: 'Australia/Sydney',
};

export function normalizeApiDateTimeText(value: unknown): string {
    const rawValue = String(value ?? '').trim();
    if (!rawValue) return '';

    if (isoDatePattern.test(rawValue)) {
        return `${rawValue}T00:00:00.000Z`;
    }

    if (isoDateTimeWithoutOffsetPattern.test(rawValue) && !timezoneOffsetPattern.test(rawValue)) {
        return `${rawValue}Z`;
    }

    return rawValue;
}

export function parseApiDateTime(value: unknown): Date | null {
    const normalized = normalizeApiDateTimeText(value);
    if (!normalized) return null;

    const parsed = new Date(normalized);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatApiDateTime(
    value: unknown,
    options: Intl.DateTimeFormatOptions = defaultDateTimeFormatOptions,
    locale: string | string[] | undefined = 'en-AU',
): string {
    const rawValue = String(value ?? '').trim();
    if (!rawValue) return 'N/A';

    const parsed = parseApiDateTime(rawValue);
    if (!parsed) return rawValue;

    return new Intl.DateTimeFormat(locale, options).format(parsed);
}

export function toApiIsoString(value: unknown): string | null {
    const rawValue = String(value ?? '').trim();
    if (!rawValue) return null;

    const parsed = parseApiDateTime(rawValue);
    return parsed ? parsed.toISOString() : rawValue;
}
